"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ValueWhenTransacted = void 0;
var _definitions = require("@ppay/definitions");
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ticker = require("../ticker");
var _ui = require("../ui");
var _utils = require("../../utils");
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var TertiaryShadeText = (0, _styledComponents.default)(_ui.Small)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.tertiaryShade;
});
var H6 = (0, _styledComponents.default)(_ui.H6)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin-bottom: 5px;\n"])));
var Wrapper = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", "\n"])), _utils.mediaQuery.lessThan('lg')(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n  "]))));
var ValueWhenTransacted = function ValueWhenTransacted(_ref2) {
  var price = _ref2.price,
    ticker = _ref2.ticker,
    value = _ref2.value;
  return /*#__PURE__*/_react.default.createElement(Wrapper, null, /*#__PURE__*/_react.default.createElement(H6, {
    className: "d-block"
  }, /*#__PURE__*/_react.default.createElement(_ticker.TickerSymbol, {
    ticker: _definitions.Ticker.USD
  }), ' ', /*#__PURE__*/_react.default.createElement(_ticker.TickerNumberFormat, {
    ticker: _definitions.Ticker.USD,
    value: value
  })), /*#__PURE__*/_react.default.createElement(TertiaryShadeText, {
    className: "d-inline-flex flex-wrap justify-content-end justify-content-md-start"
  }, /*#__PURE__*/_react.default.createElement(_ui.NumberFormat, {
    value: 1,
    decimals: 2
  }), " ", ticker, /*#__PURE__*/_react.default.createElement("div", {
    className: "ms-md-1"
  }, ' = $', " ", /*#__PURE__*/_react.default.createElement(_ticker.TickerNumberFormat, {
    value: price,
    ticker: _definitions.Ticker.USD
  }))));
};
exports.ValueWhenTransacted = ValueWhenTransacted;